import { createAjaxAction, AjaxCallback } from '../../Common/_actions/AjaxAction';
import { createAction } from '../../Common/_actions/Action';
import { Toast, EditFabrics } from '../../UIData/_actions/UIDataActions';
import { EditUserLoggedIn, EditUserValidated, EditUserFetched } from './UserDataActions';
import { EditCart } from './UserCartActions';

export enum AccountActionType {
	EditUserPrefs			= "EDIT_USER_PREFS",
	EditUserSecurity		= "EDIT_USER_SECURITY",
	AddUserAddresses		= "ADD_USER_ADDRESSES",
	EditUserAddresses		= "EDIT_USER_ADDRESSES",
	RemoveUserAddress		= "REMOVE_USER_ADDRESS",
	AddUserCreditCards		= "ADD_USER_CREDIT_CARDS",
	EditUserCreditCards		= "EDIT_USER_CREDIT_CARDS",
	RemoveUserCreditCard	= "REMOVE_USER_CREDIT_CARD",
	EditUserCurrentOrder	= "EDIT_USER_CURRENTORDER",
	RemoveAccountData		= "REMOVE_ACCOUNT_DATA"
}

///////////
// Prefs //
///////////

export const EditUserPrefs = (updates: object) => createAction(AccountActionType.EditUserPrefs, {
	updates: updates
});

export const SaveUserPrefs = (data:FormData) => createAjaxAction({
	url: "ajax/user/save-user-preferences",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if (response.data.success) {
			dispatch(EditUserPrefs(response.data.userPrefs));
			dispatch(Toast('Details changed successfully.'));
		} else {
			dispatch(Toast('Details could not be changed.'));
		}
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error) 
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Details could not be changed.'));
	}
});

export const GetUserPrefs = () => createAjaxAction({
	url: "ajax/user/get-user-preferences",
	method: "GET",
	onSuccess: (response, dispatch) => {
		if (response.data.success) {
			dispatch(EditUserPrefs(response.data.userPrefs));
		} else {
			dispatch(Toast('Something went wrong!'));
		}
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error) 
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Something went wrong!'));
	}
});

export const SaveUserCurrency = (data:FormData) => createAjaxAction({
	url: "ajax/change-currency",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if (response.data.success) {
			if(response.data.fabrics) {
				dispatch(EditFabrics(response.data.fabrics));
			}
			dispatch(EditUserPrefs(response.data.userPrefs));
			dispatch(Toast('Currency changed successfully.'));
		} else {
			dispatch(Toast('Currency could not be changed.'));
		}
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error) 
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Currency could not be changed.'));
	}
});

export const SaveUserLang = (data:FormData, onSuccess?: () => void) => createAjaxAction({
	url: "ajax/change-lang",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if (response.data.success) {
			dispatch(EditUserPrefs(response.data.userPrefs));
			dispatch(Toast('Language changed successfully.'));

			onSuccess && onSuccess()
		} else {
			dispatch(Toast('Language could not be changed.'));
		}
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error) 
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Language could not be changed.'));
	}
});

//////////////
// Security //
//////////////

export const EditUserSecurity = (updates: object) => createAction(AccountActionType.EditUserSecurity, {
	updates: updates
});

export const SaveUserSecurity = (data:FormData) => createAjaxAction({
	url: "ajax/user/save-user-security",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if(response.data.success) {
			dispatch(EditUserSecurity(response.data.userSecurity));
			dispatch(Toast('Details changed successfully'));
		} else {
			dispatch(Toast('Details could not be changed.'));
		}
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error) 
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Details could not be changed.'));
	}
});

export const GetUserSecurity = () => createAjaxAction({
	url: "ajax/user/get-user-security",
	method: "GET",
	onSuccess: (response, dispatch) => {
		if (response.data.success) {
			dispatch(EditUserSecurity(response.data.userSecurity));
		} else {
			dispatch(Toast('Something went wrong!'));
		}
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error) 
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Something went wrong!'));
	}
});

///////////////
// Addresses //
///////////////

export const CreateUserAddress = (data: FormData, callback: AjaxCallback) => createAjaxAction({
	url: "ajax/user/addresses/create-user-address",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if(response.data.success) {
			dispatch(AddUserAddresses(response.data.addresses));
			callback(response, dispatch);
			dispatch(Toast('Address updated successfully!'));
		} else {
			if(response.data.reason) {
				switch(response.data.reason) {
					case "country": dispatch(Toast("Couldn't find country."));
					case "state": dispatch(Toast("Couldn't find state."));
					case "postalcode": dispatch(Toast("Invalid postal code."));
				}
			} else {
				dispatch(Toast('Something went wrong!'));
			}
		}
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.reason) {
			switch(response.data.reason) {
				case "country": dispatch(Toast("Couldn't find country."));
				case "state": dispatch(Toast("Couldn't find state."));
				case "postalcode": dispatch(Toast("Invalid postal code."));
			}
		} else {
			dispatch(Toast('Something went wrong!'));
		}
	}
});

export const GetUserAddresses = () => createAjaxAction({
	url: "ajax/user/addresses/get-user-addresses",
	method: "GET",
	preventDuplicates: true,
	onSuccess: (response, dispatch) => {
		if(response.data.success)
			dispatch(AddUserAddresses(response.data.addresses));
		else
			dispatch(Toast('Something went wrong!'));
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Something went wrong!'));
	}
});

export const AddUserAddresses = (addresses: object) => createAction(AccountActionType.AddUserAddresses, {
	addresses: addresses
});

export const DeleteUserAddress = (data:FormData) => createAjaxAction({
	url: "ajax/user/addresses/delete-user-address",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if(response.data.success) {
			dispatch(RemoveUserAddress(response.data.id));
			dispatch(Toast('Address deleted successfully!'));
		}
		else
			dispatch(Toast('Something went wrong!'));
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Something went wrong!'));
	}
});

export const RemoveUserAddress = (id: string) => createAction(AccountActionType.RemoveUserAddress, {
	id: id
});

export const UpdateUserAddress = (data:FormData, callback?: AjaxCallback) => createAjaxAction({
	url: "ajax/user/addresses/update-user-address",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if(response.data.success) {
			dispatch(EditUserAddresses(response.data.addresses));
			dispatch(Toast('Address updated successfully!'));
			if(callback) callback(response, dispatch);
			//Update cart if one was linked to this addresss
			if(response.data.cart) {
				dispatch(EditCart(response.data.cart));
			}
		} else {
			if(response.data.reason) {
				switch(response.data.reason) {
					case "country": dispatch(Toast("Couldn't find country."));
					case "state": dispatch(Toast("Couldn't find state."));
					case "postalcode": dispatch(Toast("Invalid postal code."));
				}
			} else {
				dispatch(Toast('Something went wrong!'));
			}
		}
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.reason) {
			switch(response.data.reason) {
				case "country": dispatch(Toast("Couldn't find country."));
				case "state": dispatch(Toast("Couldn't find state."));
				case "postalcode": dispatch(Toast("Invalid postal code."));
			}
		} else {
			dispatch(Toast('Something went wrong!'));
		}
	}
});

export const EditUserAddresses = (addresses: object) => createAction(AccountActionType.EditUserAddresses, {
	addresses: addresses
});

//////////////////
// Credit Cards //
//////////////////

export const CreateUserCreditCard = (data: FormData, callback: AjaxCallback) => createAjaxAction({
	url: "ajax/user/credit-cards/create-user-credit-card",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if(response.data.success) {
			dispatch(AddUserCreditCards(response.data.creditCards));
			callback(response, dispatch);
			dispatch(Toast('Credit card added successfully!'));
		}
		else
			dispatch(Toast('Something went wrong!'));
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(response.data.errorMessage));
		else
			dispatch(Toast('Something went wrong!'));
	}
});

export const GetUserCreditCards = () => createAjaxAction({
	url: "ajax/user/credit-cards/get-user-credit-cards",
	method: "GET",
	onSuccess: (response, dispatch) => {
		if(response.data.success)
			dispatch(AddUserCreditCards(response.data.creditCards));
		else
			dispatch(Toast('Something went wrong!'));
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Something went wrong!'));
	}
});

export const AddUserCreditCards = (creditCards: object) => createAction(AccountActionType.AddUserCreditCards, {
	creditCards: creditCards
});

export const DeleteUserCreditCard = (data:FormData) => createAjaxAction({
	url: "ajax/user/credit-cards/delete-user-credit-card",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		if(response.data.success) {
			dispatch(RemoveUserCreditCard(response.data.id));
			dispatch(Toast('Credit card deleted successfully!'));
		}
		else
			dispatch(Toast('Something went wrong!'));
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error)
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Something went wrong!'));
	}
});

export const RemoveUserCreditCard = (id: string) => createAction(AccountActionType.RemoveUserCreditCard, {
	id: id
});

//////////
// Data //
//////////

export const GetAccountData = () => createAjaxAction({
	url: "ajax/account/get-account-data",
	method: "GET",
	onSuccess: (response, dispatch) => {
		if(response.data.loggedIn) {
			dispatch(EditUserLoggedIn(true));
			
			if(response.data.creditCards)
				dispatch(AddUserCreditCards(response.data.creditCards));
		} else {
			dispatch(EditUserLoggedIn(false));
		}

		if(response.data.security)
			dispatch(EditUserSecurity(response.data.security));
		
		if(response.data.addresses)
			dispatch(AddUserAddresses(response.data.addresses));

		if(response.data.prefs)
			dispatch(EditUserPrefs(response.data.prefs));

		if(response.data.validated)
			dispatch(EditUserValidated(response.data.validated));

		dispatch(EditUserFetched(true));
	},
	onFailure: (response, dispatch) => {
		if(response && response.data && response.data.error) 
			dispatch(Toast(response.data.error));
		else
			dispatch(Toast('Something went wrong!'));
	}
});

export const RemoveAccountData = () => createAction(AccountActionType.RemoveAccountData);

////////////
// Orders //
////////////

export const EditUserCurrentOrder = (order: any) => createAction(AccountActionType.EditUserCurrentOrder, {
	order: order
});

export const GetUserOrder = (data:FormData) => createAjaxAction({
	url: "ajax/user/orders/" + data.get('id'),
	method: "GET",
	abortPrevious: true,
	onSuccess: (response, dispatch) => {
		dispatch(EditUserCurrentOrder(response.data.order));
	},
	onFailure: (response, dispatch) => {
		dispatch(Toast('Something went wrong!'));
	}
});

export type AccountAction = 
	ReturnType<typeof EditUserPrefs>		|
	ReturnType<typeof EditUserSecurity>		|
	ReturnType<typeof AddUserAddresses>		|
	ReturnType<typeof EditUserAddresses>	|
	ReturnType<typeof RemoveUserAddress>	|
	ReturnType<typeof AddUserCreditCards>	|
	ReturnType<typeof RemoveUserCreditCard>	|
	ReturnType<typeof EditUserCurrentOrder>	|
	ReturnType<typeof RemoveAccountData>